import { Star, ArrowRight } from "lucide-react";
import { COLLECTION_IMAGES } from "@/constants/categoryImages";
import { COLLECTION_BLURB } from "./constants";
import { CourseGrid } from "./CourseGrid";

export function CollectionCard({ coll, user, countFor, onExplore, onOpenCourse }) {
  const { id, title, cats: ccats } = coll;
  const bannerImg = COLLECTION_IMAGES[id] || ccats.find((c) => c.image_url)?.image_url || null;
  const blurb = COLLECTION_BLURB[id] || ccats.find((c) => c.description)?.description || "";
  return (
    <div data-testid={`collection-${id}`}>
      <div className="relative overflow-hidden rounded-3xl card-soft mb-6 text-white" style={{ backgroundColor: "#291B2D" }} data-testid={`collection-banner-${id}`}>
        {bannerImg && <img src={bannerImg} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: "75% 28%" }} />}
        <div className="absolute inset-0 bg-gradient-to-r from-[#291B2D] via-[#291B2D]/85 to-[#291B2D]/30" />
        <div className="relative z-10 p-8 lg:p-10 max-w-2xl">
          {user?.preferred_collection === id && (
            <span data-testid={`collection-start-here-${id}`} className="inline-flex items-center gap-1.5 mb-3 px-3 py-1 rounded-full bg-[#C89B55] text-[#291B2D] text-[11px] font-semibold uppercase tracking-widest">
              <Star size={12} className="fill-[#291B2D]" /> Your journey · Start here
            </span>
          )}
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C89B55] font-semibold">Collection</p>
          <h2 className="font-heading text-3xl lg:text-4xl mt-1">{title}</h2>
          <p className="text-white/85 mt-3 leading-relaxed">{blurb}</p>
          <p className="text-[11px] uppercase tracking-widest text-white/60 mt-4">{ccats.length} courses · {ccats.reduce((n, c) => n + countFor(c.id), 0)} lessons</p>
          <button onClick={() => onExplore(id)} data-testid={`collection-explore-${id}`}
            className="mt-5 inline-flex items-center gap-2 bg-white/15 hover:bg-white/25 text-white rounded-full px-5 py-2.5 text-sm transition-smooth">
            Explore this journey <ArrowRight size={15} />
          </button>
        </div>
      </div>
      <CourseGrid cats={ccats} countFor={countFor} onOpen={onOpenCourse} testId={`collection-courses-${id}`} />
    </div>
  );
}
